/**
 * Error codes for User Profile Epic
 * These codes map to specific error scenarios from the API
 */

export enum UserProfileErrorCode {
  // Success codes (200)
  SUCCESS = 'USER_PROFILE_SUCCESS',

  // Validation errors (400)
  VALIDATION_ERROR = 'USER_PROFILE_VALIDATION_ERROR',
  USER_NOT_FOUND = 'USER_PROFILE_USER_NOT_FOUND',
  CURRENT_PASSWORD_INCORRECT = 'USER_PROFILE_CURRENT_PASSWORD_INCORRECT',
  PASSWORD_REQUIREMENTS_NOT_MET = 'USER_PROFILE_PASSWORD_REQUIREMENTS_NOT_MET',
  PASSWORD_REUSE_ERROR = 'USER_PROFILE_PASSWORD_REUSE_ERROR',

  // Client errors (4xx)
  UNAUTHORIZED = 'USER_PROFILE_UNAUTHORIZED',
  FORBIDDEN = 'USER_PROFILE_FORBIDDEN',
  ACCOUNT_DEACTIVATED = 'USER_PROFILE_ACCOUNT_DEACTIVATED',

  // Server errors (5xx)
  SERVER_ERROR = 'USER_PROFILE_SERVER_ERROR',
  INTERNAL_ERROR = 'USER_PROFILE_INTERNAL_ERROR',

  // Network errors
  NETWORK_ERROR = 'USER_PROFILE_NETWORK_ERROR',
  REQUEST_FAILED = 'USER_PROFILE_REQUEST_FAILED',

  // Unknown errors
  UNKNOWN_ERROR = 'USER_PROFILE_UNKNOWN_ERROR',
}

/**
 * HTTP Status code to Error Code mapping
 */
export const STATUS_TO_ERROR_CODE: Record<number, UserProfileErrorCode> = {
  200: UserProfileErrorCode.SUCCESS,
  400: UserProfileErrorCode.VALIDATION_ERROR,
  401: UserProfileErrorCode.UNAUTHORIZED,
  403: UserProfileErrorCode.FORBIDDEN,
  500: UserProfileErrorCode.SERVER_ERROR,
};
